import React from 'react';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-warm-bg" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-4xl md:text-5xl font-black text-warm-dark mb-6" data-id="element-138">
            El Miedo Paralizante a Decepcionar
          </h2>
        </div>

        <div className="space-y-8 text-lg text-warm-mid leading-relaxed" data-id="element-139">
          <p data-id="element-140">
            Muchos jóvenes deportistas de alto rendimiento viven con un miedo
            paralizante a decepcionar. Sienten que si fallan un penal, pierden
            una pelota o cometen un error técnico, no solo están perdiendo un
            punto,{' '}
            <strong className="text-warm-dark" data-id="element-141">
              están perdiendo tu orgullo y el respeto de su coach.
            </strong>
          </p>
          <p data-id="element-142">
            Este miedo activa el modo de "supervivencia" en su cerebro,
            bloqueando sus habilidades físicas. Por eso celebran poco sus
            victorias (por miedo a que la caída sea más dura) y se castigan en
            exceso por sus derrotas.
          </p>
        </div>

        <div className="mt-12 border-l-2 border-warm-dark pl-8 py-4" data-id="element-143">
          <p className="text-xl text-warm-dark italic leading-relaxed" data-id="element-144">
            "Si no se interviene, este agotamiento emocional es la razón #1 por
            la que los niños abandonan el deporte que aman antes de los 14
            años."
          </p>
        </div>
      </div>
    </section>;
}